export default __webpack_public_path__ + "static/DSC_0447-fcfa8b883347d1a153f3354cb7862135.jpg";